module.exports = __webpack_public_path__ + "static/media/logoBlueCrew.7f73c6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoBlueCrew.png
// module id = 106
// module chunks = 0